import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { SelfserviceAcknowledgementSubmission, SelfserviceActivityListUserResponse, SelfserviceDraftSelfServiceSubmission, SelfserviceFileUploadSubmission, SelfserviceGetActivityUserResponse, SelfservicePresignedStorageResource, SelfserviceSelfServiceSubmission, SelfserviceSignDocumentsSubmission, SelfserviceUpdateEmploymentHistorySubmission, SelfserviceUpdateFileUploadSubmission, SelfserviceUpdateTfrDeclarationSubmission } from "../../../../../libs/shared/generated/src/lib/types/selfservice";
import { EnvironmentService } from "../@core/services/environment.service";

@Injectable({
    providedIn: 'root',
})
export class PreEmploymentActivitiesService {
    private readonly apiUrl: string = '';

    constructor(
        private readonly http: HttpClient,
        private readonly environmentService: EnvironmentService,
    ) {
        this.apiUrl = this.environmentService.selfserviceServiceUrl + '/app/pre-employment-activities'
    }

    getAllPreEmploymentActivities(size: number = 50, page: number = 1): Observable<SelfserviceActivityListUserResponse> {
        const params = new HttpParams()
            .set('size', size.toString())
            .set('page', page.toString());
        return this.http.get<SelfserviceActivityListUserResponse>(this.apiUrl, { params });
    }

    getActivityDetail(id: string): Observable<SelfserviceGetActivityUserResponse> {
        return this.http.get<SelfserviceGetActivityUserResponse>(`${this.apiUrl}/${id}`);
    }

    getPresignedUrlForImageUpload(id: string): Observable<SelfservicePresignedStorageResource> {
        return this.http.post<SelfservicePresignedStorageResource>(`${this.apiUrl}/${id}/uploads`, {});
    }

    updateFileUploadSubmission(
        id: string,
        data: SelfserviceUpdateFileUploadSubmission
    ): Observable<void> {
        return this.http.patch<void>(`${this.apiUrl}/${id}/file-upload-submissions`, data);
    }

    updateTfrDeclarationSubmission(
        id: string,
        data: SelfserviceUpdateTfrDeclarationSubmission,
    ): Observable<void> {
        return this.http.patch<void>(`${this.apiUrl}/${id}/tfr-declaration-submissions`, data);
    }

    updateEmploymentHistorySubmission(
        id: string,
        data: SelfserviceUpdateEmploymentHistorySubmission,
    ): Observable<void> {
        return this.http.patch<void>(`${this.apiUrl}/${id}/employment-history-submissions`, data);
    }

    submitActivity(
        id: string,
        data:
            | SelfserviceSelfServiceSubmission
            | SelfserviceFileUploadSubmission
            | SelfserviceSignDocumentsSubmission
            | SelfserviceAcknowledgementSubmission,
    ): Observable<void> {
        return this.http.post<void>(`${this.apiUrl}/${id}/submissions`, data);
    }

    saveDraft(
        id: string,
        data: SelfserviceDraftSelfServiceSubmission,
    ): Observable<void> {
        return this.http.post<void>(`${this.apiUrl}/${id}/submissions/draft`, data);
    }

    validateToken(token: string): Promise<boolean> {
        return fetch(this.apiUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept-Language': 'it',
                Authorization: `Bearer ${token}`,
            },
        })
            .then((response) => response.ok)
            .catch(() => false);
    }
}